import { useRestaurantMenu } from "@vms/RestaurantMenu";
import { useMemo } from "react";
import { FilterWord, TagCategoryItem, TagItem } from "@vms/SelectFilters/SelectFiltersTypes";

export function useFiltersItems() {
    const { rawFilterData } = useRestaurantMenu();

    return useMemo(
        () => {
            const words = rawFilterData?.words || [];
            const rawTagCategories = [...(rawFilterData?.tagCategories || [])];

            const keywordItems: FilterWord[] = words.map(word => ({
                ...word,
                wordExtensions: word.wordExtensions || [],
            }));

            const tagItems: TagItem[] = words
                .filter(word => word.isTag)
                .map(word => ({
                    id: word.id!,
                    title: word.name || '',
                    categoryId: word.tagCategoryId || 0,
                }))
                .sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));

            const categoryItems: TagCategoryItem[] = rawTagCategories
                .sort((a, b) => (a.order || 0) - (b.order || 0))
                .map(cat => ({
                    id: cat.id!,
                    title: cat.name || '',
                }))
                .filter(cat => tagItems.some(tag => tag.categoryId === cat.id));

            return { keywords: keywordItems, tags: tagItems, tagCategories: categoryItems };
        },
        [rawFilterData]
    );
}